// Utilities to detect browsers that block localStorage (privacy extensions,
// Firefox strict tracking protection) and to recover from a stale/corrupted
// Supabase session stored in this browser.

export function isStorageBlocked(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const k = "__futbux_probe__";
    window.localStorage.setItem(k, "1");
    window.localStorage.removeItem(k);
    return false;
  } catch {
    return true;
  }
}

/** Removes every Supabase auth token cached by this browser. */
export function clearSupabaseAuthStorage() {
  if (typeof window === "undefined") return;
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && (k.startsWith("sb-") || k.includes("supabase.auth"))) keys.push(k);
    }
    keys.forEach((k) => window.localStorage.removeItem(k));
  } catch {
    /* storage blocked — nothing to clear */
  }
}

export function isAuthError(error: unknown): boolean {
  const msg = String((error as any)?.message ?? error ?? "").toLowerCase();
  return (
    msg.includes("unauthorized") ||
    msg.includes("sessão expirada") ||
    msg.includes("jwt") ||
    msg.includes("invalid token") ||
    msg.includes("no authorization header")
  );
}

/** Human-readable message for a failed data load in the parent portal. */
export function describeLoadError(error: unknown, fallback: string): string {
  if (isStorageBlocked()) {
    return "Seu navegador está bloqueando o armazenamento local deste site (extensão de privacidade ou proteção contra rastreamento). Libere o site futbux.com nas configurações do navegador/extensão e recarregue a página.";
  }
  if (isAuthError(error)) {
    return "Sua sessão expirou neste navegador. Saia e entre novamente para continuar.";
  }
  const msg = (error as any)?.message;
  return typeof msg === "string" && msg.trim() ? msg : fallback;
}
